/* Rescuevation · SnakE Premium (rescu-snp-*), 22.10.2026

   Bewegung ist ADDITIV: Ohne JavaScript, bei reduzierter Bewegung und wenn ein
   Beobachter nie auslöst, steht jedes Element im fertigen Zustand. Das Script
   legt nur einmalige Keyframe-Läufe darüber (Klasse snp-go, nach animationend
   wieder entfernt) und startet Schleifen nur, solange sie zu sehen sind.

   Bühne (snippets/rescu-snp-buehne): Ein Satz Düsenmodule (4 oder 6) wechselt
   zwischen Szenen. Positionen kommen aus der Tabelle ZIEL, die Schläuche werden
   in jedem Bild aus den aktuellen Modulpositionen neu gezogen. Die Liquid-
   Ausgangslage („wasser") rechnet mit denselben Zahlen.

   Kaufen: /cart/add.js, danach die Warenkorb-Schublade. Die Section-Liste kommt
   von der Schublade selbst (getSectionsToRender), weil die Live-Schublade b4c
   andere Sections rendert als Dawns Standard. */
(function () {
  'use strict';
  if (window.__rsnp) return;
  window.__rsnp = true;

  var doc = document.documentElement;
  doc.classList.add('snp-js');

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;
  var feinZeiger = window.matchMedia('(pointer: fine)').matches;
  var vh = function () { return window.innerHeight || doc.clientHeight; };
  var alle = function (wurzel, sel) { return Array.prototype.slice.call(wurzel.querySelectorAll(sel)); };
  var imBild = function (el) { var r = el.getBoundingClientRect(); return r.top < vh() - 40 && r.bottom > 0; };
  var euro = function (cent) {
    return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cent / 100) + ' €';
  };

  /* ---------- Einmalige Läufe ---------- */

  function einmal(el, klasse, dauer) {
    klasse = klasse || 'snp-go';
    var schluessel = '__snp_' + klasse;
    if (el[schluessel]) return;
    el[schluessel] = true;
    el.classList.add(klasse);
    var fertig = false;
    var ende = function (e) {
      if (fertig) return;
      if (e && e.target !== el) return;
      fertig = true;
      el.classList.remove(klasse);
      el.removeEventListener('animationend', ende);
      el[schluessel] = false;
    };
    el.addEventListener('animationend', ende);
    setTimeout(function () { ende(); }, dauer || 2600);
  }

  function staffeln(liste) {
    var gruppen = new Map();
    liste.forEach(function (el) {
      var g = el.parentElement;
      var n = gruppen.get(g) || 0;
      el.style.setProperty('--snp-d', Math.min(n * 90, 540) + 'ms');
      gruppen.set(g, n + 1);
    });
  }

  function einblenden() {
    if (ruhig || !hatIO) return;
    var els = alle(document, '.snp [data-snp-in]');
    staffeln(els);
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        einmal(e.target, 'snp-go', 2200);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      if (el.hasAttribute('data-snp-sofort')) { einmal(el, 'snp-go', 2200); return; }
      if (imBild(el)) return;
      io.observe(el);
    });
  }

  /* Schleifen (Sprühnebel, Blaulicht, Laufband) nur, solange sichtbar */
  function schleifen() {
    if (ruhig || !hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { e.target.classList.toggle('snp-spielt', e.isIntersecting); });
    }, { threshold: 0.04 });
    alle(document, '.snp [data-snp-buehne], .snp [data-snp-spiel]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Kennzahlen zählen einmal hoch ---------- */

  function zaehle(el, verzoegerung) {
    var roh = String(el.getAttribute('data-snp-zahl')).replace(',', '.');
    var ziel = parseFloat(roh);
    if (!ziel || ziel <= 0) return;
    var stellen = (roh.split('.')[1] || '').length;
    var fmt = new Intl.NumberFormat('de-DE', { minimumFractionDigits: stellen, maximumFractionDigits: stellen });
    var endText = el.textContent;
    var t0 = null;
    var dauer = 1400;
    el.textContent = fmt.format(0);
    var schritt = function (t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dauer);
      var w = 1 - Math.pow(1 - p, 4);
      el.textContent = fmt.format(ziel * w);
      if (p < 1) requestAnimationFrame(schritt); else el.textContent = endText;
    };
    setTimeout(function () { requestAnimationFrame(schritt); }, verzoegerung || 0);
  }

  function zaehlen() {
    if (ruhig || !hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        zaehle(e.target, parseInt(e.target.getAttribute('data-snp-zahl-delay') || '0', 10));
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    alle(document, '.snp [data-snp-zahl]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Bühne: Szenen ---------- */

  var BS = 1.15;
  function reihe(n) { return n === 6 ? [380, 505, 630] : [430, 590]; }

  /* Unterboden-Aufstellung: zwei Stränge, hinten (klein) und vorn */
  function unterBoden(n, dx) {
    var k = n / 2, xs = reihe(n), m = [];
    for (var i = 0; i < n; i++) {
      var hinten = i < k, x = xs[hinten ? i : i - k];
      m.push(hinten ? { x: x + 12 + dx, y: 440, r: 0, s: 0.99, o: 0.72 } : { x: x - 12 + dx, y: 454, r: 0, s: BS, o: 1 });
    }
    return m;
  }
  function straenge(n) {
    var k = n / 2, a = [], b = [];
    for (var i = 0; i < n; i++) (i < k ? a : b).push(i);
    return [{ mods: a }, { mods: b }];
  }

  var ZIEL = {
    box: function (n) {
      /* Module stehen in der Box, nur die obere Hälfte schaut über den Rand */
      var m = [], bx = n === 6 ? 10 : 20, abstand = 168 / (n - 1);
      for (var i = 0; i < n; i++) m.push({ x: bx + 36 + i * abstand, y: 418, r: 0, s: n === 6 ? 0.66 : 0.78, o: 1 });
      return { mods: m, y: { x: bx + 200, y: 452, o: 0 }, feed: null, strands: straenge(n), schlauch: false, nass: false };
    },
    koppeln: function (n) {
      return { mods: unterBoden(n, -250), y: { x: 60, y: 458, o: 1 }, feed: [-30, 476], strands: straenge(n), schlauch: true, nass: false };
    },
    schieben: function (n) {
      return { mods: unterBoden(n, 0), y: { x: 205, y: 458, o: 1 }, feed: [-30, 476], strands: straenge(n), schlauch: true, nass: false };
    },
    wasser: function (n) {
      return { mods: unterBoden(n, 0), y: { x: 205, y: 458, o: 1 }, feed: [-30, 476], strands: straenge(n), schlauch: true, nass: true };
    },
    ev: function (n) { return ZIEL.wasser(n); },
    gas: function (n) {
      var lagen = n === 6
        ? [[220, 62], [300, 52], [390, 38], [610, -38], [700, -52], [780, -62]]
        : [[300, 52], [390, 38], [610, -38], [700, -52]];
      var m = lagen.map(function (l) { return { x: l[0], y: 452, r: l[1], s: BS, o: 1 }; });
      var k = n / 2, a = [], b = [];
      for (var i = 0; i < n; i++) (i < k ? a : b).push(i);
      return { mods: m, y: { x: 120, y: 458, o: 1 }, feed: [-30, 476], strands: [{ mods: a }, { via: [[500, 476]], mods: b }], schlauch: true, nass: true };
    },
    dekon: function (n) {
      var hoehen = n === 6 ? [420, 320, 220] : [380, 250];
      var m = [];
      hoehen.forEach(function (h) { m.push({ x: 342, y: h, r: 90, s: BS, o: 1 }); });
      hoehen.forEach(function (h) { m.push({ x: 658, y: h, r: -90, s: BS, o: 1 }); });
      var k = n / 2, a = [], b = [];
      for (var i = 0; i < n; i++) (i < k ? a : b).push(i);
      return { mods: m, y: { x: 150, y: 458, o: 1 }, feed: [-30, 476], strands: [{ via: [[340, 470]], mods: a }, { via: [[500, 476], [662, 470]], mods: b }], schlauch: true, nass: true };
    },
    balken: function (n) {
      var xs = n === 6 ? [450, 350, 250, 550, 650, 750] : [420, 280, 580, 720];
      var m = xs.map(function (x) { return { x: x, y: 456, r: 180, s: 1.05, o: 1 }; });
      var k = n / 2, a = [], b = [];
      for (var i = 0; i < n; i++) (i < k ? a : b).push(i);
      return { mods: m, y: { x: 500, y: 452, o: 1 }, feed: [500, 414], strands: [{ mods: a }, { mods: b }], schlauch: true, nass: true };
    },
    regner: function (n) {
      var m = [{ x: 182, y: 352, r: 34, s: BS, o: 1, regner: true }, { x: 470, y: 438, r: 0, s: BS, o: 1, regner: true }];
      for (var i = 2; i < n; i++) m.push({ x: 470, y: 438, r: 0, s: 0.6, o: 0 });
      return { mods: m, y: { x: 70, y: 458, o: 1 }, feed: [-30, 476], strands: [{ via: [[150, 470]], mods: [0, 1] }, { mods: [] }], schlauch: true, nass: true };
    },
    ibc: function (n) {
      var xs = n === 6 ? [415, 449, 483, 517, 551, 585] : [430, 477, 523, 570];
      var s = n === 6 ? 0.82 : 0.95;
      var m = xs.map(function (x) { return { x: x, y: 240, r: 180, s: s, o: 1 }; });
      var k = n / 2, a = [], b = [];
      for (var i = 0; i < n; i++) (i < k ? a : b).push(i);
      b.reverse();
      return { mods: m, y: { x: 300, y: 458, o: 1 }, feed: [-30, 476], strands: [{ via: [[366, 470], [366, 250]], mods: a }, { via: [[640, 476], [634, 250]], mods: b }], schlauch: true, nass: true };
    }
  };

  function anker(m, seite) {
    var a = (m.r || 0) * Math.PI / 180, d = 32 * m.s * seite;
    return [m.x + Math.cos(a) * d, m.y + Math.sin(a) * d];
  }

  function bogen(p, q) {
    var mx = (p[0] + q[0]) / 2;
    var my = Math.min(472, Math.max(p[1], q[1]) + 16);
    return ' Q ' + mx.toFixed(1) + ' ' + my.toFixed(1) + ' ' + q[0].toFixed(1) + ' ' + q[1].toFixed(1);
  }

  function Buehne(el) {
    this.el = el;
    this.n = parseInt(el.getAttribute('data-n'), 10) === 6 ? 6 : 4;
    this.mods = alle(el, '.snp-m');
    this.schlauch = [el.querySelector('.snp-schlauch--a'), el.querySelector('.snp-schlauch--b')];
    this.blind = [el.querySelector('.snp-blind--a'), el.querySelector('.snp-blind--b')];
    this.zul = el.querySelector('.snp-zuleitung');
    this.yv = el.querySelector('.snp-y');
    this.zustand = null;
    this.szene = el.getAttribute('data-szene') || 'wasser';
    this.lauf = null;
    this.setzen(this.szene, true);
  }

  Buehne.prototype.zeichnen = function (z) {
    var self = this;
    z.mods.forEach(function (m, i) {
      var g = self.mods[i];
      if (!g) return;
      g.setAttribute('transform', 'translate(' + m.x.toFixed(1) + ' ' + m.y.toFixed(1) + ') rotate(' + (m.r || 0).toFixed(1) + ') scale(' + m.s.toFixed(3) + ')');
      g.style.opacity = m.o.toFixed(3);
    });
    if (this.yv) {
      this.yv.setAttribute('transform', 'translate(' + z.y.x.toFixed(1) + ' ' + z.y.y.toFixed(1) + ')');
      this.yv.style.opacity = z.y.o.toFixed(3);
    }
    if (this.zul) {
      if (z.feed) {
        var f = z.feed, ein = [z.y.x - 18, z.y.y];
        var d = 'M ' + f[0] + ' ' + f[1];
        d += (f[0] === z.y.x) ? ' L ' + ein[0] + ' ' + (z.y.y - 14) : bogen(f, ein);
        this.zul.setAttribute('d', d);
        this.zul.style.opacity = z.y.o.toFixed(3);
      } else {
        this.zul.style.opacity = '0';
      }
    }
    var ziel = this.ziel;
    (ziel.strands || []).forEach(function (st, si) {
      var pfad = self.schlauch[si];
      var blind = self.blind[si];
      if (!pfad) return;
      var sichtbar = st.mods.filter(function (i) { return z.mods[i] && z.mods[i].o > 0.3; });
      if (!sichtbar.length) { pfad.style.opacity = '0'; if (blind) blind.style.opacity = '0'; return; }
      var p = [z.y.x + 18, z.y.y + (si === 0 ? -7 : 7)];
      var d = 'M ' + p[0].toFixed(1) + ' ' + p[1].toFixed(1);
      (st.via || []).forEach(function (v) { d += bogen(p, v); p = v; });
      sichtbar.forEach(function (i) {
        var m = z.mods[i];
        var l = anker(m, -1), r = anker(m, 1);
        /* Anschluss von der näheren Seite: rechts liegende Module von links anfahren */
        var dl = Math.hypot(l[0] - p[0], l[1] - p[1]), dr = Math.hypot(r[0] - p[0], r[1] - p[1]);
        var ein = dl <= dr ? l : r, aus = dl <= dr ? r : l;
        d += bogen(p, ein) + ' L ' + aus[0].toFixed(1) + ' ' + aus[1].toFixed(1);
        p = aus;
      });
      pfad.setAttribute('d', d);
      pfad.style.opacity = ziel.schlauch ? '1' : '0';
      if (blind) {
        blind.setAttribute('cx', p[0].toFixed(1));
        blind.setAttribute('cy', p[1].toFixed(1));
        blind.style.opacity = ziel.schlauch ? '1' : '0';
      }
    });
    if (!ziel.strands || ziel.strands.length < 2) {
      if (this.schlauch[1]) this.schlauch[1].style.opacity = '0';
      if (this.blind[1]) this.blind[1].style.opacity = '0';
    }
  };

  Buehne.prototype.setzen = function (szene, sofort) {
    var fn = ZIEL[szene] || ZIEL.wasser;
    var ziel = fn(this.n);
    var self = this;
    this.szene = szene;
    this.ziel = ziel;
    this.el.setAttribute('data-szene', szene);
    this.el.setAttribute('data-schlauch', ziel.schlauch ? 'an' : 'aus');
    this.el.classList.toggle('ist-nass', !!ziel.nass);
    this.mods.forEach(function (g, i) { g.classList.toggle('ist-regner', !!(ziel.mods[i] && ziel.mods[i].regner)); });
    if (this.lauf) cancelAnimationFrame(this.lauf);
    var start = this.zustand;
    if (sofort || ruhig || !start) {
      this.zustand = JSON.parse(JSON.stringify({ mods: ziel.mods, y: ziel.y }));
      this.zeichnen({ mods: ziel.mods, y: ziel.y, feed: ziel.feed });
      return;
    }
    var t0 = null, dauer = 1150, versatz = 70;
    var ease = function (p) { return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; };
    var mix = function (a, b, p) { return a + (b - a) * p; };
    var schritt = function (t) {
      if (!t0) t0 = t;
      var gesamt = t - t0, fertig = true;
      var mods = ziel.mods.map(function (m, i) {
        var s = start.mods[i] || m;
        var p = Math.min(1, Math.max(0, (gesamt - i * versatz) / dauer));
        if (p < 1) fertig = false;
        var e = ease(p);
        return { x: mix(s.x, m.x, e), y: mix(s.y, m.y, e), r: mix(s.r || 0, m.r || 0, e), s: mix(s.s, m.s, e), o: mix(s.o, m.o, e), regner: m.regner };
      });
      var py = Math.min(1, gesamt / dauer), ey = ease(py);
      var y = { x: mix(start.y.x, ziel.y.x, ey), y: mix(start.y.y, ziel.y.y, ey), o: mix(start.y.o, ziel.y.o, ey) };
      self.zustand = { mods: mods, y: y };
      self.zeichnen({ mods: mods, y: y, feed: ziel.feed });
      if (!fertig || py < 1) self.lauf = requestAnimationFrame(schritt);
      else self.lauf = null;
    };
    this.lauf = requestAnimationFrame(schritt);
  };

  function buehneVon(el) {
    if (!el) return null;
    if (!el.__snp) el.__snp = new Buehne(el);
    return el.__snp;
  }

  /* ---------- Einsatzablauf (Film) ---------- */

  function film() {
    alle(document, '[data-snp-film]').forEach(function (sec) {
      var b = buehneVon(sec.querySelector('[data-snp-buehne]'));
      var schritte = alle(sec, '[data-snp-schritt]');
      if (!b || !schritte.length || !hatIO) return;
      sec.classList.add('snp-film--live');
      var zaehler = sec.querySelector('[data-snp-film-nr]');
      var balken = sec.querySelector('[data-snp-film-balken]');
      function aktiv(s) {
        var i = schritte.indexOf(s);
        schritte.forEach(function (x) { x.classList.toggle('ist-aktiv', x === s); });
        b.setzen(s.getAttribute('data-szene'));
        if (zaehler) zaehler.textContent = String(i + 1);
        if (balken) balken.style.setProperty('--anteil', ((i + 1) / schritte.length).toFixed(3));
      }
      var mobil = window.matchMedia('(max-width: 989px)').matches;
      var io = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) { if (e.isIntersecting) aktiv(e.target); });
      }, { rootMargin: mobil ? '-62% 0px -30% 0px' : '-45% 0px -45% 0px' });
      b.setzen(schritte[0].getAttribute('data-szene'), true);
      schritte.forEach(function (s) {
        io.observe(s);
        s.addEventListener('click', function () { aktiv(s); });
      });
      aktiv(schritte[0]);
    });
  }

  /* ---------- Einsatzlagen: Reiter oder Scroll-Strecke ---------- */

  function lagen() {
    alle(document, '[data-snp-lagen]').forEach(function (sec) {
      var b = buehneVon(sec.querySelector('[data-snp-buehne]'));
      var reiter = alle(sec, '[data-snp-reiter]');
      var tafeln = alle(sec, '[data-snp-tafel]');
      if (!tafeln.length) return;
      var modus = sec.getAttribute('data-snp-lagen');
      function zeige(i, fokus) {
        reiter.forEach(function (r, n) {
          r.setAttribute('aria-selected', String(n === i));
          r.tabIndex = n === i ? 0 : -1;
        });
        tafeln.forEach(function (t, n) {
          if (modus === 'reiter') t.hidden = n !== i;
          t.classList.toggle('ist-aktiv', n === i);
          if (n === i && modus === 'reiter' && !ruhig) einmal(t, 'snp-wechsel', 900);
        });
        if (b) b.setzen(tafeln[i].getAttribute('data-szene'));
        if (fokus && reiter[i]) reiter[i].focus();
      }
      if (modus === 'reiter') {
        sec.classList.add('snp-lagen--js');
        reiter.forEach(function (r, i) {
          r.addEventListener('click', function () { zeige(i); });
          r.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight') { e.preventDefault(); zeige((i + 1) % reiter.length, true); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); zeige((i - 1 + reiter.length) % reiter.length, true); }
          });
        });
        if (b) b.setzen(tafeln[0].getAttribute('data-szene'), true);
        zeige(0);
      } else if (hatIO) {
        sec.classList.add('snp-lagen--live');
        var mobil = window.matchMedia('(max-width: 989px)').matches;
        var io = new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) { if (e.isIntersecting) zeige(tafeln.indexOf(e.target)); });
        }, { rootMargin: mobil ? '-60% 0px -30% 0px' : '-45% 0px -45% 0px' });
        tafeln.forEach(function (t) { io.observe(t); });
        reiter.forEach(function (r, i) {
          r.addEventListener('click', function () { tafeln[i].scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'center' }); });
        });
        if (b) b.setzen(tafeln[0].getAttribute('data-szene'), true);
        zeige(0);
      }
    });
    /* Einzelne Bühnen ohne Steuerung: Szene aus data-start */
    alle(document, '[data-snp-buehne][data-start]').forEach(function (el) {
      var b = buehneVon(el);
      if (b) b.setzen(el.getAttribute('data-start'), true);
    });
  }

  /* ---------- Düsenmodul-Anatomie ---------- */

  function anatomie() {
    alle(document, '[data-snp-anatomie]').forEach(function (sec) {
      var bild = sec.querySelector('[data-snp-explosion]');
      if (bild && !ruhig && hatIO) {
        var io = new IntersectionObserver(function (e) {
          if (!e[0].isIntersecting) return;
          io.disconnect();
          einmal(bild, 'snp-zusammen', 2600);
        }, { threshold: 0.4 });
        io.observe(bild);
      }
      alle(sec, '[data-snp-teil]').forEach(function (li) {
        var teil = li.getAttribute('data-snp-teil');
        var an = function () { sec.setAttribute('data-hervor', teil); };
        var aus = function () { sec.removeAttribute('data-hervor'); };
        li.addEventListener('pointerenter', an);
        li.addEventListener('pointerleave', aus);
        li.addEventListener('focusin', an);
        li.addEventListener('focusout', aus);
      });
    });
  }

  /* ---------- Packliste: Auspacken und Hervorheben ---------- */

  function packliste() {
    alle(document, '[data-snp-packliste]').forEach(function (sec) {
      var tisch = sec.querySelector('[data-snp-pk-tisch]');
      if (tisch && tisch.tagName.toLowerCase() === 'figure' && !ruhig && hatIO) {
        var io = new IntersectionObserver(function (e) {
          if (!e[0].isIntersecting) return;
          io.disconnect();
          einmal(tisch, 'snp-pk-zusammen', 2400);
        }, { threshold: 0.35 });
        io.observe(tisch);
      }
      alle(sec, '[data-snp-teil]').forEach(function (li) {
        var teil = li.getAttribute('data-snp-teil');
        var an = function () { sec.setAttribute('data-hervor', teil); };
        var aus = function () { sec.removeAttribute('data-hervor'); };
        li.addEventListener('pointerenter', an);
        li.addEventListener('pointerleave', aus);
        li.addEventListener('focusin', an);
        li.addEventListener('focusout', aus);
      });
    });
  }

  /* ---------- Vergleich mit Schieberegler ---------- */

  function regler() {
    alle(document, '[data-snp-regler]').forEach(function (sec) {
      var feld = sec.querySelector('.snp-vg-regler');
      var input = sec.querySelector('[data-snp-regler-input]');
      if (!feld || !input) return;
      var setzen = function (v) { feld.style.setProperty('--pos', v + '%'); };
      input.addEventListener('input', function () { setzen(input.value); });
      if (ruhig || !hatIO) return;
      var io = new IntersectionObserver(function (e) {
        if (!e[0].isIntersecting) return;
        io.disconnect();
        /* einmal kurz hin und her, Ruhezustand bleibt 50 % */
        var punkte = [50, 72, 30, 50], t0 = null, dauer = 2600;
        var schritt = function (t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dauer), abschnitt = p * (punkte.length - 1);
          var i = Math.min(punkte.length - 2, Math.floor(abschnitt)), f = abschnitt - i;
          var e2 = f < 0.5 ? 2 * f * f : 1 - Math.pow(-2 * f + 2, 2) / 2;
          var v = punkte[i] + (punkte[i + 1] - punkte[i]) * e2;
          setzen(v.toFixed(1)); input.value = Math.round(v);
          if (p < 1) requestAnimationFrame(schritt);
        };
        setTimeout(function () { requestAnimationFrame(schritt); }, 400);
      }, { threshold: 0.5 });
      io.observe(feld);
    });
  }

  /* ---------- Galerie ---------- */

  function galerie() {
    alle(document, '[data-snp-galerie]').forEach(function (g) {
      var band = g.querySelector('[data-snp-band]');
      var minis = alle(g, '[data-snp-mini]');
      if (!band) return;
      var bilder = alle(band, '.snp-galerie__bild');
      var aktuell = 0;
      var gehe = function (i) {
        i = Math.max(0, Math.min(bilder.length - 1, i));
        band.scrollTo({ left: bilder[i].offsetLeft, behavior: ruhig ? 'auto' : 'smooth' });
      };
      var markieren = function () {
        var i = Math.round(band.scrollLeft / Math.max(1, band.clientWidth));
        if (i === aktuell) return;
        aktuell = i;
        minis.forEach(function (m, n) { m.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        var zaehler = g.querySelector('[data-snp-zaehler]');
        if (zaehler) zaehler.textContent = String(i + 1);
      };
      band.addEventListener('scroll', function () { window.requestAnimationFrame(markieren); }, { passive: true });
      minis.forEach(function (m, i) { m.addEventListener('click', function () { gehe(i); }); });
      var vor = g.querySelector('[data-snp-vor]');
      var zurueck = g.querySelector('[data-snp-zurueck]');
      if (vor) vor.addEventListener('click', function () { gehe(aktuell + 1 >= bilder.length ? 0 : aktuell + 1); });
      if (zurueck) zurueck.addEventListener('click', function () { gehe(aktuell - 1 < 0 ? bilder.length - 1 : aktuell - 1); });
      band.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); gehe(aktuell + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); gehe(aktuell - 1); }
      });
    });
  }

  /* ---------- Warenkorb ---------- */

  function inDenWarenkorb(items) {
    var schublade = document.querySelector('cart-drawer');
    var body = { items: items };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (daten) {
        if (!res.ok || daten.status) throw new Error(daten.description || daten.message || 'HTTP ' + res.status);
        return daten;
      });
    }).then(function (daten) {
      try {
        if (schublade && typeof schublade.renderContents === 'function' && daten.sections) {
          schublade.classList.remove('is-empty');
          schublade.renderContents(daten);
        } else {
          window.location.href = root + 'cart';
        }
      } catch (e) {
        window.location.href = root + 'cart';
      }
      return daten;
    });
  }

  var HAKEN = '<svg class="snp-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5l4.8 4.8L19.5 7"/></svg>';

  function knopfLaeuft(btn, an) {
    if (!btn) return;
    if (an) {
      if (!btn.__snpLabel) btn.__snpLabel = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span>Wird hinzugefügt …</span>';
    } else {
      btn.disabled = false;
      if (btn.__snpLabel) btn.innerHTML = btn.__snpLabel;
    }
  }

  function knopfOk(btn) {
    if (!btn) return;
    var label = btn.__snpLabel || btn.innerHTML;
    btn.disabled = false;
    btn.classList.add('ist-ok');
    btn.innerHTML = HAKEN + '<span>Im Warenkorb</span>';
    setTimeout(function () { btn.classList.remove('ist-ok'); btn.innerHTML = label; }, 2400);
  }

  function stepper() {
    alle(document, '[data-snp-stepper]').forEach(function (st) {
      var feld = st.querySelector('input');
      var setzen = function (n) {
        var min = parseInt(feld.min || '1', 10), max = parseInt(feld.max || '99', 10);
        feld.value = Math.max(min, Math.min(max, n || min));
        feld.dispatchEvent(new Event('snp:anzahl', { bubbles: true }));
      };
      st.querySelector('[data-snp-minus]').addEventListener('click', function () { setzen(parseInt(feld.value, 10) - 1); });
      st.querySelector('[data-snp-plus]').addEventListener('click', function () { setzen(parseInt(feld.value, 10) + 1); });
      feld.addEventListener('change', function () { setzen(parseInt(feld.value, 10)); });
    });
  }

  function kaufFormular() { return document.querySelector('[data-snp-form]'); }

  /* Zustand der Auswahl, an dem Kaufleiste, Lieferumfang und Anfrage hängen */
  var AUSWAHL = { name: '', variante: '', id: 0, preis: 0, anzahl: 1, zusatz: [] };

  function auswahlText() {
    var t = AUSWAHL.name + (AUSWAHL.variante ? ', ' + AUSWAHL.variante : '') + ', ' + AUSWAHL.anzahl + ' Stück';
    if (AUSWAHL.zusatz.length) t += ' + ' + AUSWAHL.zusatz.map(function (z) { return z.titel; }).join(' + ');
    return t;
  }

  function auswahlMelden() {
    document.dispatchEvent(new CustomEvent('snp:auswahl', { detail: AUSWAHL }));
  }

  function kauf() {
    var form = kaufFormular();
    if (form) {
      var sec = form.closest('[data-snp-kauf]');
      var btn = form.querySelector('[data-snp-submit]');
      var fehler = form.querySelector('[data-snp-fehler]');
      var idFeld = form.querySelector('[data-snp-variante]');
      var anzahl = form.querySelector('[data-snp-anzahl]');
      var preisEl = sec && sec.querySelector('.snp-preis__betrag[data-snp-preis]');
      var bruttoEl = sec && sec.querySelector('[data-snp-brutto]');
      var summeEl = sec && sec.querySelector('[data-snp-summe]');
      var summeZeile = sec && sec.querySelector('[data-snp-summe-zeile]');
      AUSWAHL.name = form.getAttribute('data-snp-name') || '';

      var zusatzListe = sec ? alle(sec, '[data-snp-zusatz]') : [];

      function rechnen() {
        var r = sec && sec.querySelector('[data-snp-wahl]:checked');
        if (r) {
          AUSWAHL.id = parseInt(r.value, 10);
          AUSWAHL.preis = parseInt(r.getAttribute('data-preis'), 10);
          AUSWAHL.variante = r.getAttribute('data-titel') || '';
        } else {
          AUSWAHL.id = parseInt(idFeld.value, 10);
          AUSWAHL.preis = parseInt(form.getAttribute('data-snp-startpreis') || '0', 10);
        }
        idFeld.value = AUSWAHL.id;
        AUSWAHL.anzahl = Math.max(1, parseInt(anzahl && anzahl.value, 10) || 1);
        AUSWAHL.zusatz = zusatzListe.filter(function (z) { return z.checked; }).map(function (z) {
          return { id: parseInt(z.value, 10), preis: parseInt(z.getAttribute('data-preis'), 10), titel: z.getAttribute('data-titel') };
        });
        if (preisEl) preisEl.textContent = euro(AUSWAHL.preis);
        if (bruttoEl) bruttoEl.textContent = euro(Math.round(AUSWAHL.preis * 1.19));
        if (summeEl) {
          var s = AUSWAHL.preis * AUSWAHL.anzahl;
          AUSWAHL.zusatz.forEach(function (z) { s += z.preis; });
          summeEl.textContent = euro(s);
          if (summeZeile) summeZeile.hidden = AUSWAHL.zusatz.length === 0 && AUSWAHL.anzahl === 1;
        }
        if (btn) {
          var lbl = btn.querySelector('[data-snp-submit-text]');
          if (lbl) lbl.textContent = AUSWAHL.zusatz.length ? (btn.getAttribute('data-paket') || 'Paket in den Warenkorb') : (btn.getAttribute('data-einzeln') || 'In den Warenkorb');
        }
        auswahlMelden();
      }

      if (sec) {
        alle(sec, '[data-snp-wahl]').forEach(function (r) {
          r.addEventListener('change', function () {
            rechnen();
            try {
              var u = new URL(window.location.href);
              u.searchParams.set('variant', r.value);
              window.history.replaceState({}, '', u.toString());
            } catch (e) { /* nichts */ }
          });
        });
        zusatzListe.forEach(function (z) { z.addEventListener('change', rechnen); });
      }
      if (anzahl) anzahl.addEventListener('snp:anzahl', rechnen);
      rechnen();

      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var items = [{ id: AUSWAHL.id, quantity: AUSWAHL.anzahl }];
        AUSWAHL.zusatz.forEach(function (z) { items.push({ id: z.id, quantity: 1 }); });
        if (fehler) { fehler.hidden = true; fehler.textContent = ''; }
        knopfLaeuft(btn, true);
        inDenWarenkorb(items).then(function () { knopfOk(btn); }).catch(function (err) {
          knopfLaeuft(btn, false);
          if (fehler) {
            fehler.hidden = false;
            fehler.textContent = (err && err.message) ? err.message : 'Das hat nicht geklappt. Bitte versuch es noch einmal oder ruf uns an.';
          }
        });
      });
    }

    /* Weitere Warenkorb-Knöpfe (Kaufleiste, Zubehör, Einsatzlagen) */
    document.addEventListener('click', function (e) {
      var k = e.target.closest && e.target.closest('[data-snp-in-korb]');
      if (!k || !window.fetch) return;
      var wert = k.getAttribute('data-snp-in-korb');
      var id = parseInt(wert === 'auswahl' ? AUSWAHL.id : wert, 10);
      if (!id) return;
      e.preventDefault();
      var n = wert === 'auswahl' ? AUSWAHL.anzahl : 1;
      var schmal = k.classList.contains('snp-btn--icon') || (k.classList.contains('snp-sticky__korb') && window.matchMedia('(max-width: 749px)').matches);
      knopfLaeuft(k, true);
      inDenWarenkorb([{ id: id, quantity: n }]).then(function () {
        if (schmal) { k.disabled = false; k.innerHTML = HAKEN; setTimeout(function () { k.innerHTML = k.__snpLabel; }, 2400); }
        else knopfOk(k);
      }).catch(function () {
        knopfLaeuft(k, false);
        var ziel = document.getElementById('kaufen');
        if (ziel) ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth' });
      });
    });
  }

  /* Kaufleiste und Lieferumfang folgen der Auswahl */
  function folgen() {
    document.addEventListener('snp:auswahl', function () {
      alle(document, '[data-snp-folgt="preis"]').forEach(function (el) { el.textContent = euro(AUSWAHL.preis); });
      alle(document, '[data-snp-folgt="brutto"]').forEach(function (el) { el.textContent = euro(Math.round(AUSWAHL.preis * 1.19)); });
      alle(document, '[data-snp-folgt="variante"]').forEach(function (el) { el.textContent = AUSWAHL.variante; });
      var mitRahmen = /mit\s.*(rahmen)/i.test(AUSWAHL.variante) || /advanced/i.test(AUSWAHL.variante);
      alle(document, '[data-snp-rahmen]').forEach(function (el) {
        var soll = el.getAttribute('data-snp-rahmen');
        el.classList.toggle('ist-aus', (soll === 'mit') !== mitRahmen);
      });
      var f = formular();
      if (f) {
        var feld = f.querySelector('[data-snp-f="auswahl"]');
        var chip = f.querySelector('[data-snp-auswahl-text]');
        if (feld && !feld.__snpManuell) feld.value = auswahlText();
        if (chip && !(feld && feld.__snpManuell)) chip.textContent = auswahlText();
      }
    });
  }

  /* ---------- Anfrage vorbefüllen ---------- */

  function formular() { return document.querySelector('[data-snp-formular]'); }

  function feldSetzen(f, name, wert) {
    var el = f.querySelector('[data-snp-f="' + name + '"]');
    if (!el || wert == null) return;
    if (el.tagName === 'SELECT') {
      for (var i = 0; i < el.options.length; i++) {
        if (el.options[i].value === wert) { el.selectedIndex = i; return; }
      }
    } else {
      el.value = wert;
    }
  }

  function vorbelegen(daten) {
    var f = formular();
    if (!f || !daten) return;
    Object.keys(daten).forEach(function (k) {
      if (k === 'text') {
        var t = f.querySelector('[data-snp-f="text"]');
        if (!t) return;
        var zeile = daten.text;
        if (/^Anliegen:/.test(t.value)) t.value = t.value.replace(/^Anliegen:[^\n]*/, zeile);
        else t.value = zeile + (t.value ? '\n' + t.value : '');
      } else if (k === 'auswahl') {
        var a = f.querySelector('[data-snp-f="auswahl"]');
        var chip = f.querySelector('[data-snp-auswahl-text]');
        if (a) { a.value = daten.auswahl; a.__snpManuell = true; }
        if (chip) chip.textContent = daten.auswahl;
      } else {
        feldSetzen(f, k, daten[k]);
      }
    });
  }

  function anliegen() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-snp-anliegen]');
      if (!a) return;
      var daten = { anliegen: a.getAttribute('data-snp-anliegen') };
      var extra = a.getAttribute('data-snp-vorbelegung');
      if (extra) { try { Object.assign(daten, JSON.parse(extra)); } catch (err) { /* nichts */ } }
      /* Knöpfe mit der aktuellen Systemwahl übernehmen sie als Auswahl und folgen ihr wieder */
      if (a.hasAttribute('data-snp-mit-auswahl') && !daten.auswahl) {
        var f = formular();
        var feld = f && f.querySelector('[data-snp-f="auswahl"]');
        var chip = f && f.querySelector('[data-snp-auswahl-text]');
        if (feld) { feld.__snpManuell = false; feld.value = auswahlText(); }
        if (chip) chip.textContent = auswahlText();
      }
      vorbelegen(daten);
    });
  }

  /* ---------- Rechner: Wie lange reicht Dein Tank? ---------- */

  function rechner() {
    alle(document, '[data-snp-rechner]').forEach(function (sec) {
      var proDuese = { '3': parseFloat(sec.getAttribute('data-l3') || '18'), '5': parseFloat(sec.getAttribute('data-l5') || '23') };
      var tank = sec.querySelector('[data-snp-r-tank]');
      var tankWert = sec.querySelector('[data-snp-r-tank-wert]');
      var aus = {
        fluss: sec.querySelector('[data-snp-r="fluss"]'),
        dauer: sec.querySelector('[data-snp-r="dauer"]'),
        stunde: sec.querySelector('[data-snp-r="stunde"]')
      };
      var pegel = sec.querySelector('[data-snp-r-pegel]');
      var knopf = sec.querySelector('[data-snp-r-angebot]');
      var duesenBild = sec.querySelector('[data-snp-r-duesen]');
      var fmt0 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
      var fmt1 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
      function wert(name) {
        var el = sec.querySelector('input[name="' + sec.id + '-' + name + '"]:checked');
        return el ? el.value : '';
      }
      function rechnen() {
        var n = parseInt(wert('duesen') || '4', 10);
        var bar = wert('druck') || '5';
        var l = parseInt(tank.value, 10);
        var fluss = n * proDuese[bar];
        var min = l / fluss;
        if (tankWert) tankWert.textContent = fmt0.format(l) + ' l';
        if (aus.fluss) aus.fluss.textContent = fmt0.format(fluss);
        if (aus.dauer) aus.dauer.textContent = fmt1.format(min);
        if (aus.stunde) aus.stunde.textContent = fmt0.format(fluss * 60);
        if (pegel) pegel.style.setProperty('--dauer', Math.max(2, Math.min(18, min / 4)).toFixed(2) + 's');
        if (duesenBild) duesenBild.setAttribute('data-n', String(n));
        if (knopf) {
          knopf.setAttribute('data-snp-vorbelegung', JSON.stringify({
            text: 'Anliegen: Wasserbedarf geprüft, ' + n + ' Düsen bei ' + bar + ' bar = ' + fmt0.format(fluss) + ' l/min, Tank ' + fmt0.format(l) + ' l reicht rechnerisch ' + fmt1.format(min) + ' Minuten.'
          }));
        }
      }
      alle(sec, 'input').forEach(function (i) { i.addEventListener('input', rechnen); i.addEventListener('change', rechnen); });
      rechnen();
    });
  }

  /* ---------- Video erst auf Klick laden ---------- */

  function videos() {
    alle(document, '[data-snp-video]').forEach(function (v) {
      var knopf = v.querySelector('button');
      if (!knopf) return;
      knopf.addEventListener('click', function () {
        var id = v.getAttribute('data-snp-video');
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
        f.title = v.getAttribute('data-titel') || 'Video';
        f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        f.loading = 'lazy';
        v.classList.add('ist-laeuft');
        v.innerHTML = '';
        v.appendChild(f);
      });
    });
  }

  /* ---------- Kino-Bühne: Sprühnebel als Partikel + Zeigerlicht ---------- */

  function nebel() {
    if (ruhig) return;
    alle(document, '[data-snp-nebel]').forEach(function (cv) {
      var ctx = cv.getContext && cv.getContext('2d');
      if (!ctx) return;
      var sec = cv.closest('.snp');
      var teile = [], w = 0, h = 0, dpr = Math.min(2, window.devicePixelRatio || 1), laeuft = false, zeiger = null;
      function groesse() {
        var r = cv.getBoundingClientRect();
        w = r.width; h = r.height;
        cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var ziel = Math.round(Math.min(150, w * h / 9000));
        while (teile.length < ziel) teile.push(neu(true));
        teile.length = ziel;
      }
      function neu(irgendwo) {
        return {
          x: Math.random() * w,
          y: irgendwo ? Math.random() * h : h + 20,
          r: 18 + Math.random() * 60,
          vx: (Math.random() - 0.5) * 0.25,
          vy: -(0.15 + Math.random() * 0.45),
          a: 0.025 + Math.random() * 0.05
        };
      }
      function bild() {
        if (!laeuft) return;
        ctx.clearRect(0, 0, w, h);
        teile.forEach(function (p, i) {
          if (zeiger) {
            var dx = p.x - zeiger[0], dy = p.y - zeiger[1], d2 = dx * dx + dy * dy;
            if (d2 < 22000) { p.vx += dx / 9000; p.vy += dy / 12000; }
          }
          p.vx *= 0.985; p.x += p.vx; p.y += p.vy;
          if (p.y < -p.r * 2 || p.x < -120 || p.x > w + 120) teile[i] = neu(false);
          var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
          g.addColorStop(0, 'rgba(255,255,255,' + p.a + ')');
          g.addColorStop(1, 'rgba(255,255,255,0)');
          ctx.fillStyle = g;
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
        });
        requestAnimationFrame(bild);
      }
      groesse();
      window.addEventListener('resize', groesse, { passive: true });
      if (feinZeiger && sec) {
        sec.addEventListener('pointermove', function (e) {
          var r = cv.getBoundingClientRect();
          zeiger = [e.clientX - r.left, e.clientY - r.top];
          sec.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          sec.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
        sec.addEventListener('pointerleave', function () { zeiger = null; });
      }
      if (hatIO) {
        new IntersectionObserver(function (e) {
          var an = e[0].isIntersecting;
          if (an && !laeuft) { laeuft = true; cv.classList.add('ist-an'); requestAnimationFrame(bild); }
          if (!an) laeuft = false;
        }).observe(cv);
      }
    });
  }

  /* ---------- Kaufleiste ---------- */

  function leiste() {
    var st = document.querySelector('[data-snp-sticky]');
    if (!st || !hatIO) return;
    /* Maßgeblich ist die eigene Kaufreihe: Ist sie nicht im Bild, steht die Leiste,
       auch ganz oben (Paketbauer schiebt die Kaufreihe unter den ersten Bildschirm). */
    var kaufForm = document.querySelector('.snp-kaufreihe') || kaufFormular();
    var kontakt = document.getElementById('ContactForm');
    var fuss = document.querySelector('footer, .footer, #shopify-section-footer');
    var kaufSichtbar = true, kontaktSichtbar = false, fussSichtbar = false, tief = true;
    function pruefen() {
      var zeigen = tief && !kaufSichtbar && !kontaktSichtbar && !fussSichtbar;
      if (zeigen) {
        if (st.hidden) {
          st.hidden = false;
          st.classList.add('ist-weg');
          requestAnimationFrame(function () { requestAnimationFrame(function () { st.classList.remove('ist-weg'); st.classList.add('is-aktiv'); }); });
        } else { st.classList.remove('ist-weg'); st.classList.add('is-aktiv'); }
      } else if (!st.hidden) {
        st.classList.add('ist-weg');
        st.classList.remove('is-aktiv');
      }
    }
    if (kaufForm) new IntersectionObserver(function (e) { kaufSichtbar = e[0].isIntersecting; pruefen(); }).observe(kaufForm);
    else kaufSichtbar = false;
    if (kontakt) new IntersectionObserver(function (e) { kontaktSichtbar = e[0].isIntersecting; pruefen(); }).observe(kontakt);
    if (fuss) new IntersectionObserver(function (e) { fussSichtbar = e[0].isIntersecting; pruefen(); }).observe(fuss);
  }

  /* ---------- Videoausschnitte (26.10.2026) ----------
     Das Vorschaubild steht immer. Das Video lädt erst, wenn der Ausschnitt ins
     Bild kommt, spielt nur dort und liegt erst sichtbar darüber, wenn es läuft.
     Bei reduzierter Bewegung oder Datensparmodus startet es nur per Knopf. */

  function clips() {
    var liste = alle(document, '[data-snp-clip]');
    if (!liste.length) return;
    var sparen = !!(navigator.connection && navigator.connection.saveData);
    var selbst = !ruhig && !sparen;
    liste.forEach(function (box) {
      var v = box.querySelector('video');
      var knopf = box.querySelector('[data-snp-clip-knopf]');
      var quelle = box.getAttribute('data-snp-clip');
      if (!v || !quelle) return;
      var angehalten = !selbst;
      function spielen() {
        if (!v.getAttribute('src')) v.src = quelle;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      function anhalten() { if (!v.paused) v.pause(); }
      function zeigen() {
        box.classList.toggle('ist-angehalten', angehalten);
        if (knopf) knopf.setAttribute('aria-label', angehalten ? 'Ausschnitt abspielen' : 'Ausschnitt anhalten');
      }
      v.addEventListener('playing', function () { box.classList.add('ist-an'); });
      if (knopf) {
        knopf.hidden = false;
        knopf.addEventListener('click', function () {
          angehalten = !angehalten;
          if (angehalten) anhalten(); else spielen();
          zeigen();
        });
      }
      zeigen();
      if (!hatIO) { if (!angehalten) spielen(); return; }
      new IntersectionObserver(function (e) {
        if (e[0].isIntersecting && !angehalten) spielen(); else anhalten();
      }, { threshold: 0.35 }).observe(box);
    });
  }

  /* ---------- Start ---------- */

  function start() {
    stepper();
    galerie();
    folgen();
    kauf();
    anliegen();
    film();
    lagen();
    anatomie();
    packliste();
    regler();
    rechner();
    videos();
    clips();
    nebel();
    einblenden();
    schleifen();
    zaehlen();
    leiste();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
